/* Attitude Waves — theme.js (vanilla, sem dependências) */
(function () {
  'use strict';

  /* ---------- utilitários ---------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const money = (cents) => {
    const fmt = (window.AW && window.AW.moneyFormat) || '€ {{amount_with_comma_separator}}';
    const v = (cents / 100);
    const withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withDot = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', withComma.split(',')[0])
      .replace('{{amount}}', withDot)
      .replace('{{amount_no_decimals}}', withDot.split('.')[0]);
  };

  /* ---------- painéis (drawer do menu, pesquisa) ---------- */
  const openPanel = (id) => {
    const p = document.getElementById(id);
    if (!p) return;
    p.hidden = false;
    void p.offsetWidth; // força reflow para a transição correr
    p.classList.add('is-open');
    document.body.classList.add('panel-open');
    const first = p.querySelector('input, a, button');
    if (first) first.focus({ preventScroll: true });
  };
  const closePanel = (p) => {
    if (!p) return;
    p.classList.remove('is-open');
    document.body.classList.remove('panel-open');
    setTimeout(() => { p.hidden = true; }, 200);
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openPanel(opener.getAttribute('data-open')); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closePanel(closer.closest('.panel')); return; }
    if (e.target.classList && e.target.classList.contains('panel__backdrop')) closePanel(e.target.closest('.panel'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.panel.is-open').forEach(closePanel);
  });

  /* ---------- quantidade ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    if (!input) return;
    const step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
    const min = parseInt(input.min || '1', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let v = parseInt(input.value || '1', 10) + step;
    v = Math.max(min, Math.min(max, v));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  // no carrinho, mudar a quantidade submete o formulário
  $$('form[data-cart-form] input[name="updates[]"]').forEach((input) => {
    input.addEventListener('change', () => input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit());
  });

  /* ---------- seletor de variantes (página de produto) ---------- */
  $$('[data-product-form]').forEach((wrapper) => {
    const dataEl = wrapper.querySelector('[data-variants]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    const idInput = wrapper.querySelector('input[name="id"]');
    const priceEl = wrapper.querySelector('[data-price]');
    const compareEl = wrapper.querySelector('[data-compare]');
    const stockEl = wrapper.querySelector('[data-stock]');
    const submit = wrapper.querySelector('[data-submit]');
    const submitLabel = submit ? submit.querySelector('[data-submit-label]') : null;
    const labels = {
      add: wrapper.getAttribute('data-label-add') || 'Adicionar ao carrinho',
      soldout: wrapper.getAttribute('data-label-soldout') || 'Esgotado',
      unavailable: wrapper.getAttribute('data-label-unavailable') || 'Indisponível',
      instock: wrapper.getAttribute('data-label-instock') || 'Em stock',
      low: wrapper.getAttribute('data-label-low') || 'Últimas unidades',
    };
    const lowThreshold = parseInt(wrapper.getAttribute('data-low-threshold') || '0', 10);
    const optionGroups = $$('[data-option-index]', wrapper);

    const selected = () => optionGroups.map((g) => {
      const active = g.querySelector('[aria-pressed="true"]');
      return active ? active.getAttribute('data-value') : null;
    });

    const findVariant = (opts) => variants.find((v) => opts.every((o, i) => o === null || v.options[i] === o));

    const render = () => {
      const opts = selected();
      const variant = findVariant(opts);
      // marca valores esgotados em cada grupo (dado o resto da seleção)
      optionGroups.forEach((g, gi) => {
        $$('[data-value]', g).forEach((btn) => {
          const test = opts.slice(); test[gi] = btn.getAttribute('data-value');
          const match = variants.find((v) => test.every((o, i) => o === null || v.options[i] === o));
          const available = !!(match && match.available);
          btn.classList.toggle('is-soldout', !available);
        });
      });
      if (!variant) {
        if (submit) { submit.disabled = true; if (submitLabel) submitLabel.textContent = labels.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { compareEl.textContent = money(variant.compare_at_price); compareEl.hidden = false; priceEl && priceEl.classList.add('price--sale'); }
        else { compareEl.hidden = true; priceEl && priceEl.classList.remove('price--sale'); }
      }
      if (stockEl) {
        if (!variant.available) { stockEl.textContent = labels.soldout; stockEl.className = 'product__stock product__stock--out'; }
        else if (variant.inventory_management && lowThreshold > 0 && variant.inventory_quantity <= lowThreshold) { stockEl.textContent = labels.low + (variant.inventory_quantity > 0 ? ' — ' + variant.inventory_quantity : ''); stockEl.className = 'product__stock product__stock--low'; }
        else { stockEl.textContent = labels.instock; stockEl.className = 'product__stock'; }
      }
      if (submit) {
        submit.disabled = !variant.available;
        if (submitLabel) submitLabel.textContent = variant.available ? labels.add + ' — ' + money(variant.price) : labels.soldout;
      }
      // imagem da variante
      if (variant.featured_media_id) {
        const thumb = wrapper.closest('.product') && wrapper.closest('.product').querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (thumb) thumb.click();
      }
      // URL
      try { const u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u.toString()); } catch (err) {}
    };

    optionGroups.forEach((g) => {
      g.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-value]');
        if (!btn) return;
        e.preventDefault();
        $$('[data-value]', g).forEach((b) => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        render();
      });
    });
    render();
  });

  /* ---------- adicionar ao carrinho (AJAX) + surf code ---------- */
  $$('form[data-ajax-add]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const codeInput = form.querySelector('[data-surf-code]');
      const code = codeInput ? (codeInput.value || '').trim().toUpperCase() : '';
      if (!window.fetch) return; // submissão normal
      e.preventDefault();
      const submit = form.querySelector('[data-submit]');
      if (submit) submit.disabled = true;
      const fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then((r) => { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(() => {
          window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart' : '/cart';
        })
        .catch(() => { if (submit) submit.disabled = false; form.submit(); });
    });
  });

  /* ---------- galeria de produto ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = $$('[data-media-id]', gallery);
    const dots = $$('[data-dot]', gallery);
    const show = (id) => {
      $$('[data-gallery-item]', main).forEach((item) => { item.hidden = item.getAttribute('data-gallery-item') !== id; });
      thumbs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-media-id') === id));
      dots.forEach((d) => d.classList.toggle('is-active', d.getAttribute('data-dot') === id));
    };
    thumbs.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); show(t.getAttribute('data-media-id')); }));
    dots.forEach((d) => d.addEventListener('click', () => show(d.getAttribute('data-dot'))));
    // swipe simples no mobile
    let startX = null;
    main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) < 40) return;
      const items = $$('[data-gallery-item]', main);
      const idx = items.findIndex((i) => !i.hidden);
      const next = dx < 0 ? Math.min(items.length - 1, idx + 1) : Math.max(0, idx - 1);
      show(items[next].getAttribute('data-gallery-item'));
    }, { passive: true });
  });

  /* ---------- separadores (página legal, etc.) ---------- */
  $$('[data-tabs]').forEach((tabs) => {
    const buttons = $$('[data-tab]', tabs);
    const panels = $$('[data-tab-panel]', tabs);
    const activate = (id, push) => {
      buttons.forEach((b) => b.classList.toggle('is-active', b.getAttribute('data-tab') === id));
      panels.forEach((p) => { p.hidden = p.getAttribute('data-tab-panel') !== id; });
      if (push) { try { history.replaceState(null, '', '#' + id); } catch (err) {} }
    };
    buttons.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); activate(b.getAttribute('data-tab'), true); }));
    const hash = window.location.hash.replace('#', '');
    if (hash && panels.some((p) => p.getAttribute('data-tab-panel') === hash)) activate(hash, false);
    else if (buttons[0]) activate(buttons[0].getAttribute('data-tab'), false);
  });

  /* ---------- código de desconto no carrinho ---------- */
  $$('[data-discount-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const code = (form.querySelector('input').value || '').trim().toUpperCase();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    });
  });

  /* ---------- barra de anúncio: cabeçalho compacto ao fazer scroll ---------- */
  const header = $('[data-header]');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      last = y;
    }, { passive: true });
  }
})();
